import React, { useContext } from 'react';
import { Card } from 'react-bootstrap';
import DealContext from '../DealContext';
import PickCustomer from '../PickCustomer';
import { modal } from '../../modal/ModalEmitter';
import ApiService from '../../../services/ApiService';

const BillingCustomerCard = () => {
  const { deal, fetchDeal } = useContext(DealContext);

  const hasBillingCustomer = !!deal.BillingCustomer;

  const handleBillingCustomerSubmit = payload => {
    const { customerId } = payload;

    if (customerId) {
      return ApiService.put(`crm/deal/${String(deal.id)}/change-billing`, { customerId }).then(() => {
        modal.close();
        fetchDeal(); // TODO Perf
      });
    }
  };

  const handleBillingCustomerSetup = () => {
    modal.open('pickCustomer', {
      style: 'center',
      size: 'sm',
      hideFooter: true,
      hidePrint: true,
      staticBackdrop: true,
      title: 'Billing Customer',
      message: <PickCustomer onSubmit={handleBillingCustomerSubmit} />,
    });
  };

  const handleRemoveBillingCustomer = () => {
    // TODO Faster callback
    return ApiService.put(`crm/deal/${String(deal.id)}/remove-billing`).then(fetchDeal);
  };

  return (
    <Card className="customer-card">
      {hasBillingCustomer ? (
        <>
          <div className="card-toolbar">
            <div className="card-toolbar-button" onClick={handleRemoveBillingCustomer} title="Remove Billing Customer">
              <i className="fas fa-trash fa-fw" />
            </div>
          </div>
          <Card.Body>
            <Card.Title>Billing Customer</Card.Title>
            {`${deal.BillingCustomer.fullName} ${
              deal.BillingCustomer['Company Name'] !== deal.BillingCustomer.fullName
                ? `(${deal.BillingCustomer['Company Name']})`
                : ''
            }`}
            <div>{deal.BillingCustomer.Address}</div>
            <div>
              {deal.BillingCustomer.City} {deal.BillingCustomer.State} {deal.BillingCustomer.Zip}
            </div>
            <div>{deal.BillingCustomer.Phone}</div>
          </Card.Body>
        </>
      ) : (
        <Card.Body className="p-0">
          <div className="setup-banner p-3" onClick={handleBillingCustomerSetup}>
            <i className="fas fa-user-plus mr-2" /> Setup Alternate Billing Customer
          </div>
        </Card.Body>
      )}
    </Card>
  );
};

export default BillingCustomerCard;
